import React, { useState } from "react";
import { ButtonComp, ModalCompAdvance } from "../../../components";
import PendingMemberComp from "./modules/PendingMember";
import { useGetPendingMembersQuery } from "../../../store/admin/memberManagement/memberSlice";
import { useMemo } from "react";
// import TablePagination from "../../../components/Table/Pagination";
import useMemberRegAction from "./useMemberRegAction";
import PendingMemberDetailsModal from "./modules/PendingMemberDetailsModal";

export default function PendingMember() {
  const [modalToggle, setModalToggle] = useState(false);
  const [modalPage, setModalPage] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [memberId, setMemeberId] = useState(null);
  const [detailsModalOpen, setDetailsModalOpen] = useState(false);
  const [selectedMemberId, setSelectedMemberId] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [clearSelectedRows, setClearSelectedRows] = useState(false);
  const [isBulkApproving, setIsBulkApproving] = useState(false);
  const { acceptMember, rejectMember, acceptMembersBulk } =
    useMemberRegAction();

  const { error, data, isFetching } = useGetPendingMembersQuery(pageNumber);
  const { allMembers = [], pagination = {} } = useMemo(() => {
    const fetchedMembers = data?.members || [];
    const pagination = data?.pagination || {};
    const perPage = pagination?.perPage || 5;
    const formattedMembers = fetchedMembers.map((item, index) => {
      return {
        name: item.first_name + " " + item.last_name,
        phone: item.phone,
        email: item.email,
        status: item.status,
        branch: item.branch.name,
        photo: item.photo,
        serialNumber: index + 1 + (pageNumber - 1) * perPage,
        id: item.id,
        is_active: item.is_activated,
      };
    });
    return { allMembers: formattedMembers, pagination };
  }, [data, pageNumber]);

  if (error) {
    console.log(error);
  }

  // Get the selected member's details for the modal
  const selectedMember = allMembers.find((member) => member.id === memberId);
  const branchName = selectedMember?.branch || "the branch";
  const bulkCount = selectedIds.length;

  const resetSelection = () => {
    setSelectedIds([]);
    setClearSelectedRows((prev) => !prev);
  };

  const handleSelectedRowsChange = ({ selectedRows }) => {
    const ids = (selectedRows || [])
      .map((row) => row?.id)
      .filter((id) => id != null);
    setSelectedIds(ids);
  };

  const handlePageChange = (page) => {
    resetSelection();
    setPageNumber(page);
  };

  const useModal = [
    {
      name: "Confirm Modal",
      component: (
        <div>
          <div className="py-3"></div>
          <div className="text-center">
            <h4 className="text-black text-center fw-bold">Confirm Approval</h4>
            <p className="mb-5 text-black fw-2">
              Are you sure you want to approve this member&apos;s registration
              for <strong>{branchName}</strong>?
            </p>
            <div className="row justify-content-around">
              <div className="col-5">
                <ButtonComp
                  onClick={() => setModalToggle(false)}
                  btnText={"No"}
                  btnClassName={" text-1 btn w-100 py-3"}
                  BorderColor={"var(--color-primary)"}
                />
              </div>
              <div className="col-5">
                <ButtonComp
                  ButtonInlineStyle={{ background: "#FF4343" }}
                  btnText={"Yes"}
                  btnClassName={"border-0 text-white rounded w-100 py-3"}
                  onClick={() => {
                    acceptMember(memberId).finally(() => {
                      setModalToggle(false);
                    });
                  }}
                />
              </div>
            </div>
          </div>
          <div className="py-3"></div>
        </div>
      ),
    },
    {
      name: "Decline Modal",
      component: (
        <div>
          <div className="py-3"></div>
          <div className="text-center">
            <h4 className="text-black text-center fw-bold">Confirm Decline</h4>
            <p className="mb-5 text-black fw-2">
              Are you sure you want to decline this member&apos;s registration?
              This action cannot be undone.
            </p>
            <div className="row justify-content-around">
              <div className="col-5">
                <ButtonComp
                  onClick={() => setModalToggle(false)}
                  btnText={"No"}
                  btnClassName={" text-1 btn w-100 py-3"}
                  BorderColor={"var(--color-primary)"}
                />
              </div>
              <div className="col-5">
                <ButtonComp
                  ButtonInlineStyle={{ background: "#FF4343" }}
                  btnText={"Yes"}
                  btnClassName={"border-0 text-white rounded w-100 py-3"}
                  onClick={() => {
                    rejectMember(memberId).finally(() => setModalToggle(false));
                  }}
                />
              </div>
            </div>
          </div>
          <div className="py-3"></div>
        </div>
      ),
    },
    {
      name: "Bulk Approve Modal",
      component: (
        <div>
          <div className="py-3"></div>
          <div className="text-center">
            <h4 className="text-black text-center fw-bold">
              Confirm Bulk Approval
            </h4>
            <p className="mb-5 text-black fw-2">
              Approve <strong>{bulkCount}</strong> pending member
              {bulkCount === 1 ? "" : "s"} for this branch? Each member will
              receive login credentials by email and/or SMS where available.
            </p>
            <div className="row justify-content-around">
              <div className="col-5">
                <ButtonComp
                  onClick={() => setModalToggle(false)}
                  btnText={"No"}
                  btnClassName={" text-1 btn w-100 py-3"}
                  BorderColor={"var(--color-primary)"}
                  disabled={isBulkApproving}
                />
              </div>
              <div className="col-5">
                <ButtonComp
                  ButtonInlineStyle={{ background: "#19BC31" }}
                  btnText={isBulkApproving ? "Approving…" : "Yes, approve"}
                  btnClassName={"border-0 text-white rounded w-100 py-3"}
                  disabled={isBulkApproving || bulkCount === 0}
                  onClick={async () => {
                    if (bulkCount === 0 || isBulkApproving) return;
                    setIsBulkApproving(true);
                    try {
                      await acceptMembersBulk(selectedIds.slice(0, 50));
                      resetSelection();
                      setModalToggle(false);
                    } finally {
                      setIsBulkApproving(false);
                    }
                  }}
                />
              </div>
            </div>
          </div>
          <div className="py-3"></div>
        </div>
      ),
    },
  ];
  const handleViewDetails = (id) => {
    setSelectedMemberId(id);
    setDetailsModalOpen(true);
  };

  const handleApproveFromDetails = async () => {
    if (!selectedMemberId) return;
    setIsProcessing(true);
    try {
      await acceptMember(selectedMemberId);
      setDetailsModalOpen(false);
      setSelectedMemberId(null);
    } catch (error) {
      console.error("Error approving member:", error);
    } finally {
      setIsProcessing(false);
    }
  };

  const handleDeclineFromDetails = async () => {
    if (!selectedMemberId) return;
    setIsProcessing(true);
    try {
      await rejectMember(selectedMemberId);
      setDetailsModalOpen(false);
      setSelectedMemberId(null);
    } catch (error) {
      console.error("Error declining member:", error);
    } finally {
      setIsProcessing(false);
    }
  };

  const openBulkApproveModal = () => {
    if (selectedIds.length === 0 || isBulkApproving) return;
    setModalPage(2);
    setModalToggle(true);
  };

  return (
    <>
      <ModalCompAdvance
        modalBody={modalPage}
        show={modalToggle}
        arrayComp={useModal}
        handleClose={() => {
          if (!isBulkApproving) setModalToggle(false);
        }}
        centered
        size={"md"}
      />
      <PendingMemberDetailsModal
        show={detailsModalOpen}
        handleClose={() => {
          setDetailsModalOpen(false);
          setSelectedMemberId(null);
        }}
        memberId={selectedMemberId}
        onApprove={handleApproveFromDetails}
        onDecline={handleDeclineFromDetails}
        isProcessing={isProcessing}
      />
      <PendingMemberComp
        modalPage={modalPage}
        setModalPage={setModalPage}
        useModal={useModal}
        setModalToggle={setModalToggle}
        title={"Pending members"}
        tableData={allMembers}
        isFetching={isFetching}
        pagination={pagination}
        setPageNumber={handlePageChange}
        setMemberId={setMemeberId}
        onViewDetails={handleViewDetails}
        onSelectedRowsChange={handleSelectedRowsChange}
        clearSelectedRows={clearSelectedRows}
        selectedCount={selectedIds.length}
        onBulkApproveClick={openBulkApproveModal}
        isBulkApproving={isBulkApproving}
      />
    </>
  );
}
